import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core';
import React from 'react';
import { useResourcingChartToolbarContext } from '~/modules/projects/resourcing-plan/hooks';
import { mapScaleToPeriodResolution } from '~/modules/resourcing/common/util';
import ResourcePlanGrandTotal from '../ResourcePlanGrandTotal';
import ResourceAllocationChartFooter from '../ChartFooters/ResourceAllocationChartFooter';
import { useProjectTotals2 } from '../ChartFooters/hooks/useProjectTotals2';

const useStyles = makeStyles(theme => ({
  emptyFooter: {
    height: theme.spacing(4.625)
  }
}));

export const TotalsFooterContainer = ({
  handleDirectResourceAllocationSubmit,
  createAllocationExistingUserLoading,
  allocateResourcePopupAnchorEl,
  allocateResourcePopupMenuClose,
  allocateResourcePopupClick,
  setExistingResourceAllocation,
  existingResourceAllocation,
  isSmartFitOpen
}) => {
  const classes = useStyles();
  const {
    filter,
    scale,
    dateRange,
    isResourceActualModeEnabled,
    isShowColumnarTotalsEnabled
  } = useResourcingChartToolbarContext();

  const {
    loading,
    allocationsTotals,
    resourceRequestsTotals,
    allocationPeriodTotals,
    resourceRequestPeriodTotals
  } = useProjectTotals2({
    filter,
    includeActualsResourceUsers: isResourceActualModeEnabled,
    dateRange: isShowColumnarTotalsEnabled ? dateRange : null,
    periodResolution: mapScaleToPeriodResolution(scale)
  });

  const showGrandTotals = Boolean(
    (allocationsTotals?.totalHours || allocationsTotals?.totalCost?.amount) &&
      (resourceRequestsTotals?.totalHours ||
        resourceRequestsTotals?.totalCost?.amount)
  );

  return (
    <>
      <ResourceAllocationChartFooter
        handleDirectResourceAllocationSubmit={
          handleDirectResourceAllocationSubmit
        }
        allocationsTotals={allocationsTotals}
        loading={loading}
        allocationPeriodTotals={allocationPeriodTotals}
        createAllocationExistingUserLoading={
          createAllocationExistingUserLoading
        }
        allocateResourcePopupAnchorEl={allocateResourcePopupAnchorEl}
        allocateResourcePopupMenuClose={allocateResourcePopupMenuClose}
        allocateResourcePopupClick={allocateResourcePopupClick}
        isSmartFitOpen={isSmartFitOpen}
        setExistingResourceAllocation={setExistingResourceAllocation}
        existingResourceAllocation={existingResourceAllocation}
      />
      {showGrandTotals ? (
        <ResourcePlanGrandTotal
          loading={loading}
          allocationsTotals={allocationsTotals}
          resourceRequestsTotals={resourceRequestsTotals}
          allocationPeriodTotals={allocationPeriodTotals}
          resourceRequestPeriodTotals={resourceRequestPeriodTotals}
        />
      ) : (
        <div className={classes.emptyFooter}></div>
      )}
    </>
  );
};

TotalsFooterContainer.propTypes = {
  handleDirectResourceAllocationSubmit: PropTypes.func.isRequired,
  createAllocationExistingUserLoading: PropTypes.bool,
  allocateResourcePopupAnchorEl: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.node
  ]),
  allocateResourcePopupMenuClose: PropTypes.func.isRequired,
  allocateResourcePopupClick: PropTypes.func.isRequired,
  setExistingResourceAllocation: PropTypes.func,
  existingResourceAllocation: PropTypes.object,
  isSmartFitOpen: PropTypes.bool
};

export default TotalsFooterContainer;
